import React from "react";
import { Members } from "./../Home/Member/member";

//  President
import Prof_Uma_Shanker_Tiwary from "./../../Images/Prof_Uma_Shanker_Tiwary.jpg"

//  Conference Chair
import Prof_Dhananjay_Singh from "./../../Images/Prof_Dhananjay_Singh.jpg"

// Steering Committee

import Prof_Tom_D_Gedeon from "./../../Images/Prof_Tom_D_Gedeon.jpg";
import Prof_Debasis_Samanta from "./../../Images/Prof_Debasis_Samanta.jpg";
import Prof_Santanu_Chaudhury from "./../../Images/Prof_Santanu_Chaudhury.jpg";
import Dr_Atanendu_Sekhar_Mandal from "./../../Images/Dr_Atanendu_Sekhar_Mandal.jpg";
import Prof_Jaroslav_Pokorny from "./../../Images/Prof_Jaroslav_Pokorny.jpg";
import Professor_Sukhendu_Das from "./../../Images/Professor_Sukhendu_Das.jpg";
// import Prof_Uma_Shanker_Tiwary from "./../../Images/Prof_Uma_Shanker_Tiwary.jpg";
import Professor_Tanveer_Siddiqui from "./../../Images/Professor_Tanveer_Siddiqui.jpg";
import Professor_Samit_Bhattacharya from "./../../Images/Professor_Samit_Bhattacharya.jpg";
import Professor_Wan_Young_Chung from "./../../Images/Prof_Wan_Young_Chung.jpg";
// import Prof_Dhananjay_Singh from "./../../Images/Prof_Dhananjay_Singh.jpg";
import Professor_Mriganka_Sur from "./../../Images/Professor_Mriganka_Sur.jpg";
import Professor_Javed_Khan from "./../../Images/Professor_Javed_Khan.JPG";
import Professor_Hakimjon_Zaynidinov from "./../../Images/Professor_Hakimjon_Zaynidinov.jpg";
import Prof_Dae_Ki_Kang from "./../../Images/Prof_Dae_Ki_Kang.jpg";
import Prof_Ajay_Gupta from "./../../Images/Prof_Ajay_Gupta.jpg";

// Operation Chairs
import Dr_Jong_Hoon_Kim from "./../../Images/Dr_Jong_Hoon_Kim.png";
import Dr_Madhusudan_Singh from "./../../Images/Dr_Madhusudan_Singh.jpg";
import Dr_Naagmani_Molakatala from "./../../Images/Dr_Naagmani_Molakatala.jpg";
import Dr_Koumudi_Patil from "./../../Images/Dr_Koumudi_Patil.jpg";
import Dr_Mario_Jose_Divan from "./../../Images/Dr_Mario_Jose_Divan.jpg";
import Dr_Ikechi_Ukaegbu from "./../../Images/Dr_Ikechi_Ukaegbu.jpg";
import Garima_Bajpai from "./../../Images/Garima_Bajpai.jpg";
import Dr_Mohd_Helmy_Bin_Abd_Wahab from "./../../Images/Dr_Mohd_Helmy_Bin_Abd_Wahab.jpg";
import Dr_Arvind_W_Kiwelekar from "./../../Images/Dr_Arvind_W_Kiwelekar.jpg";

export const Steering = () => {
  //    President
  const Name1 = ["Prof. Uma Shanker Tiwary"];

  const Info1 = [
    "Uma Shanker Tiwary Professor, Department of Information Technology, Indian Institute of Information Technology, Allahabad, India",
  ];

  const P_website1 = [""];

  const Pic1 = [Prof_Uma_Shanker_Tiwary];

  //   Conference Chair
  const Name2 = ["Prof. Dhananjay Singh"];

  const Info2 = [
    "Professor in the School of Professional Studies Saint Louis University, MO, USA",
  ];

  const P_website2 = [""];

  const Pic2 = [Prof_Dhananjay_Singh];

  //  Steering Committee
  const Name3 = [
    "Professor Tom D. Gedeon ",
    "Professor Debasis Samanta",
    "Professor Santanu Chaudhury",
    "Dr. Atanendu Sekhar Mandal",
    "Professor Jaroslav Pokorný",
    "Professor Sukhendu Das",
    "professor Uma Shanker Tiwary ",
    "Professor Tanveer Siddiqui",
    "Professor Samit Bhattacharya ",
    "Professor Wan-Young Chung",
    "Professor Dhananjay Singh",
    "Professor Mriganka Sur",
    "Professor Javed Khan",
    "Professor Hakimjon Zaynidinov ",
    "Professor Dae- Ki Kang",
    "Professor Ajay Gupta ",
  ];

  const Info3 = [
    "ANU College of Engineering, Computing & Cybernetics Australian National University, Australia",
    "Department of Computer Science and Engineering Indian Institute of Technology Kharagpur",
    "Department of Electrical Engineering IIT Delhi",
    "Chief Scientist CSIR-CEERI, Pilani, India",
    "Department of Software Engineering Charles University in Prague Czechia",
    "Department of Computer Science IIT-Madras, India",
    "Department of Information Technology Indian Institute of Information Technology Allahabad, India",
    "Department of Electronics Engineering University of Allahabad, India",
    "Department of Computer Science IIT-Guwahati, India",
    "Full Professor in the Department of Electronics Engineering Pukyong National University, Busan, South Korea",
    "Department of Electronics Engineering and Division of Global IT Hankuk University of Foreign Studies (HUFS) Seoul, South Korea",
    "Dir, Simons Ctr for the Social Brain, Newton Prof Brain & Cognitive Sciences Massachusetts Institute of Technology [MIT], USA",
    "Department of Computer Science Kent State University, Kent OH, USA",
    "Department of Artificial Intelligence TUIT named after Muhammad al Khwarizmi, Tashkent, Uzbekistan",
    "Department of Computer Science Dongseo University, Busan, South Korea",
    "Department of Computer Science Western Michigan University, Kalamazoo, USA",
  ];

  const P_website3 = [
    "https://researchers.anu.edu.au/researchers/gedeon-td",
    "https://cse.iitkgp.ac.in/~dsamanta/",
    "https://web.iitd.ac.in/~santanuc/",
    "https://www.linkedin.com/in/atanendu-sekhar-mandal-224124103/?originalSubdomain=in",
    "https://www.ksi.mff.cuni.cz/~pokorny/",
    "http://cse.iitm.ac.in/~sdas/",
    "https://www.cogcomp.in/faculty/",
    "https://www.iitg.ac.in/samit/",
    "https://www.iitg.ac.in/samit/",
    "http://usnlab.pknu.ac.kr/",
    "https://www.resenselab.org/members",
    "https://bcs.mit.edu/directory/mriganka-sur",
    "https://www.kent.edu/node/javed-khan",
    "https://tuit.uz/en/suniy-intellekt",
    "https://scholar.google.com/citations?user=U7OeExwAAAAJ&hl=en",
    "https://cs.wmich.edu/~gupta/",
  ];

  const Pic3 = [
    Prof_Tom_D_Gedeon,
    Prof_Debasis_Samanta,
    Prof_Santanu_Chaudhury,
    Dr_Atanendu_Sekhar_Mandal,
    Prof_Jaroslav_Pokorny,
    Professor_Sukhendu_Das,
    Prof_Uma_Shanker_Tiwary,
    Professor_Tanveer_Siddiqui,
    Professor_Samit_Bhattacharya,
    Professor_Wan_Young_Chung,
    Prof_Dhananjay_Singh,
    Professor_Mriganka_Sur,
    Professor_Javed_Khan,
    Professor_Hakimjon_Zaynidinov,
    Prof_Dae_Ki_Kang,
    Prof_Ajay_Gupta,
  ];

  //   Operation Chairs
  const Name4 = [
    "Dr. Jong-Hoon Kim",
    "Dr. Madhusudan Singh",
    "Dr. Naagmani Molakatala",
    "Dr. Koumudi Patil",
    "Dr. Mario Jose Divan",
    "Dr. Ikechi Ukaegbu",
    "Garima Bajpai",
    "Dr. Mohd Helmy Bin Abd Wahab",
    "Dr. Arvind W. Kiwelekar",
  ];

  const Info4 = [
    "ATR lab, Department Computer Science, Kent State University, Kent, USA",
    "Oregon Institute of Technology, Klamath Falls, USA",
    "School of Computer and Information Sciences, University of Hyderabad, India",
    "Department of Humanities and Social Sciences, IIT-Kanpur, Kanpur, India",
    "Sr. Solutions Architect and Service Lead. IOTG Services, Intel Corporation, USA",
    "Department of Electrical and Computer Engineering, Nazarbayev University, Nur-Sultan, Kazakhstan",
    "Canada DevOps Community of Practice, Canada",
    "Computer Engineering, University Tun Hussein Onn Malaysia, Malaysia",
    "Computer Engineering, Dr. Babasaheb Ambedkar Tech. University, India",
  ];

  const P_website4 = ["", "", "", "", "", "", "", "", ""];

  const Pic4 = [
    Dr_Jong_Hoon_Kim,
    Dr_Madhusudan_Singh,
    Dr_Naagmani_Molakatala,
    Dr_Koumudi_Patil,
    Dr_Mario_Jose_Divan,
    Dr_Ikechi_Ukaegbu,
    Garima_Bajpai,
    Dr_Mohd_Helmy_Bin_Abd_Wahab,
    Dr_Arvind_W_Kiwelekar,
  ];

  return (
    <section className="container">
      <Members
        heading="PRESIDENT"
        Name={Name1}
        Info={Info1}
        P_website={P_website1}
        Pic={Pic1}
      />
      <Members
        heading="CONFERENCE CHAIR"
        Name={Name2}
        Info={Info2}
        P_website={P_website2}
        Pic={Pic2}
      />
      <Members
        heading="STEERING COMMITTEE"
        Name={Name3}
        Info={Info3}
        P_website={P_website3}
        Pic={Pic3}
      />
      <Members
        heading="OPERATION CHAIR"
        Name={Name4}
        Info={Info4}
        P_website={P_website4}
        Pic={Pic4}
      />
      <hr className="hr-style" />
    </section>
  );
};
